/* globals google */

import Cookie from 'js-cookie'

import store from 'base/store'
import { resetUserAndAddresses } from 'base/actions/asynchronous'
import { receiveInitialSession, updateVisitor } from 'base/actions/synchronous'

const ERROR = 'Google authentication failed. Please try again.'

export default function googleConnect({ siteLocation = 'generic google' }) {
  Cookie.remove('g_state') // Keep cookie cleanup

  async function signIn(signInData) {
    const xhr = new XMLHttpRequest()
    xhr.open('POST', '/auth/google_gis/callback')
    xhr.setRequestHeader('Content-Type', 'application/json')

    return new Promise((resolve, reject) => {
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          const session = JSON.parse(xhr.responseText).session
          store.dispatch(receiveInitialSession(session))
          store.dispatch(updateVisitor(session.visitor))
          store.dispatch(resetUserAndAddresses(session.user))
          resolve(session)
        } else {
          reject(new Error(xhr.responseText))
        }
      }

      xhr.onerror = () => {
        reject(new Error('Network Error'))
      }

      xhr.send(JSON.stringify(signInData))
    })
  }

  return new Promise((resolve, reject) => {
    google.accounts.id.initialize({
      client_id: store.getState().appConfig.googleAuthApiKey,
      scope: 'email profile',
      ux_mode: 'popup',
      auto_select: true,
      cancel_on_tap_outside: false,
      use_fedcm_for_prompt: true,
      callback: async response => {
        if (response && response.credential) {
          try {
            const signInResponse = await signIn({ ...response, site_location: siteLocation })
            resolve(signInResponse)
          } catch (err) {
            reject(new Error(ERROR))
          }
        } else {
          reject(new Error(ERROR))
        }
      },
    })

    google.accounts.id.prompt()
  })
}
